import React, {useState, useRef} from 'react';
import {Link, useStaticQuery, graphql} from 'gatsby';
import cx from 'classnames';
import {Index} from 'lunr';
import {Modal, Slide} from '@mui/material';
import Div100vh from 'src/components/div100vh';
import {Backdrop} from 'src/components/backdrop';
import {Image} from 'src/components/image';
import {useStoreContext, useToggleSearch} from 'src/context/storeContext';
import {Price} from 'src/components/price';
import {ReactComponent as Arrow} from 'src/images/svg/Arrow.svg';

import * as styles from './search-drawer.module.css';

export const SearchDrawer = () => {
	const {searchIsOpen, noticeBarVisible} = useStoreContext();
	const toggleSearch = useToggleSearch();

	const [query, setQuery] = useState('');
	const inputEl = useRef(null);

	const handleChange = e => {
		setQuery(e.target.value);
	};

	const data = useStaticQuery(graphql`
		query {
			LunrIndex
		}
	`);

	// LunrIndex is available via page query
	const {store} = data.LunrIndex;
	// lunr in action here
	const index = Index.load(data.LunrIndex.index);
	let results = [];
	if (query !== '') {
		try {
			// search is a lunr method
			results = index.search(query).map(({ref}) => {
				// Map search results to an array of {slug, title, excerpt} objects
				return {
					slug: ref,
					...store[ref],
				};
			});
			console.log(results);
		} catch (error) {
			console.log(error);
		}
	}

	return (
		<Modal
			open={searchIsOpen}
			onClose={() => toggleSearch()}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{active: searchIsOpen, toggle: toggleSearch}}
			aria-modal="true"
			aria-labelledby="searchTitle">
			<Slide
				direction="left"
				in={searchIsOpen}
				timeout={{
					enter: 500,
					exit: 250,
				}}>
				<div
					className={cx(
						styles.searchDrawer,
						noticeBarVisible ? styles.noticeBarVisible : '',
					)}>
					<Div100vh className={cx(styles.contentContainer)}>
						<div className={styles.inner}>
							<h2 id="searchTitle" className="visually-hidden">
								Search
							</h2>
							<input
								className={cx('small-headline', styles.input)}
								ref={inputEl}
								id="searchInput"
								type="text"
								value={query}
								placeholder="Type to search..."
								onChange={handleChange}
							/>

							{results?.length > 0 && (
								<div className={styles.results}>
									{results.map(product => (
										<Link
											key={product.slug}
											to={`/products/${product.slug}`}
											className={styles.product}
											onClick={toggleSearch}>
											<div className={styles.thumbnail}>
												{product.imageId && (
													<Image
														className={
															styles.thumbnailImage
														}
														imageId={
															product.imageId
														}
														alt={product.title}
														style={{
															objectFit: 'cover',
															height: '100%',
														}}
													/>
												)}
											</div>
											<div className={styles.details}>
												<div
													className={
														styles.titlePrice
													}>
													<span
														className={cx(
															'small-headline',
															styles.productTitle,
														)}>
														{product.title}
													</span>
													{product.sold ? (
														<span className="label-caps">
															Sold!
														</span>
													) : (
														<span className="italic">
															{product.isAcrostic && (
																<span>
																	from{' '}
																</span>
															)}
															<Price
																price={
																	product.price
																}
															/>
														</span>
													)}
												</div>
												<span
													className={cx(
														'label-italic',
														styles.shop,
													)}>
													Shop <Arrow />
												</span>
											</div>
										</Link>
									))}
								</div>
							)}
						</div>
					</Div100vh>
				</div>
			</Slide>
		</Modal>
	);
};
